"use strict";

var _reactPureCheck = require("react-pure-check");

var _functionComUtils = require("function-com-utils"); // 注册唯一键值

/**
 * Array Map Unique
 * 
 * Author : chenchao
 * 
 * Date : 2019-07-30
 * 
 */


var RegisterMapUnique = function RegisterMapUnique() {
  if (Array.prototype.hasOwnProperty("uniqueMap") && (0, _reactPureCheck.Types)(Array.prototype.uniqueMap) === "function") return false;

  Array.prototype.uniqueMap = function (cb) {
    var useUnique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var originArr = this,
        finalRes = []; // error cache

    if ((0, _reactPureCheck.Types)(cb) !== "function") {
      (0, _functionComUtils.errorLog)(cb + " is not a function");
      return [];
    }

    if ((0, _reactPureCheck.Types)(originArr) !== "array") {
      (0, _functionComUtils.errorLog)("uniqueMap method only support a array");
      return [];
    } // 获取唯一的key


    var getUniqueKey = new Date().getTime(); // 循环查找并且创建 key

    for (var index = 0; index < originArr.length; index++) {
      // have key
      if (useUnique && (0, _reactPureCheck.Types)(originArr[index]) === "object" && !originArr[index].hasOwnProperty("unique_key")) {
        originArr[index]["unique_key"] = getUniqueKey + "_" + index;
      }

      finalRes.push(cb(originArr[index], index, [].concat(originArr)));
    }

    return finalRes;
  };

  return true;
};

module.exports = RegisterMapUnique;